// @flow

import get from 'lodash/get';
import forEach from 'lodash/forEach';
import isNaN from 'lodash/isNaN';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import {
  TYPE_TEXT_FIELD,
  TYPE_SELECT_FIELD,
  TEXTTYPE_NUMBER,
  TYPE_DATE_FIELD,
} from '../../constants';

/* 
  This function is used to update the format of input values coming from UI 
  and filter out invalid values, in order to comply with Metadata's accepted values and formats
*/
const updateFormResponse = (components: Object = {}, response: Object = {}) => {
  const newResponse = {};
  forEach(response, (value, key) => {
    const component = components[key];
    switch (component.type) {
      case TYPE_SELECT_FIELD:
        // If Single Select
        if (component.multiSelect !== true) {
          const selectValue = get(value, '0'); // no fallback so could be undefined
          // Set response only if item is selected
          if (!isNil(selectValue)) {
            newResponse[key] = selectValue;
          }
          // If Multi Select, set response only if item is selected
        } else if (!isEmpty(value)) {
          newResponse[key] = value;
        }
        break;
      case TYPE_DATE_FIELD:
        // Set response only if date is defined
        if (value !== undefined && value !== null) {
          newResponse[key] = value;
        }
        break;
      case TYPE_TEXT_FIELD:
        // If number field
        if (component.textType === TEXTTYPE_NUMBER) {
          const float = parseFloat(value);
          // Set response only if it is a valid number
          if (!isNaN(float)) {
            newResponse[key] = float;
          }
          // If text field, set response only if defined
        } else if (value !== undefined && value !== null && !isEmpty(value)) {
          newResponse[key] = value;
        }
        break;
      default:
        newResponse[key] = value;
    }
  });
  return newResponse;
};

export default updateFormResponse;
